module.exports = __webpack_public_path__ + "img/CRC2_Neutrophils.b1756f85.png";